export default {"src":"/_next/static/media/mail-forwarding.eb2707a5.svg","height":72,"width":72};